import {
  InsuranceOrder,
  InsuranceOrganizationProduct,
  InsuranceOtpTimerData,
  ResponseInsuranceOrderWithFile,
  ResponseInsuranceOrder,
} from '@/modules/bia/shared/model/types';

import { SERVICE_CODES } from '@/lib/consts';

import { client } from '../../core/client';

import type { DataResponse } from '../../types';

export const bia = {
  insuranceOrders: (without_expired = false): Promise<DataResponse<ResponseInsuranceOrder[]>> => {
    return client.get(
      `/insurance-orders?${new URLSearchParams({ 'filters[not_expired]': without_expired ? '1' : '0' })}`,
    );
  },
  insuranceOrder: (insurance_order_id: string): Promise<DataResponse<ResponseInsuranceOrderWithFile>> => {
    return client.get(`/insurance-orders/${insurance_order_id}`);
  },
  products: (request_id: string): Promise<DataResponse<InsuranceOrganizationProduct[]>> => {
    return client.get(`/user-requests/${SERVICE_CODES.INSURANCE}/products?${new URLSearchParams({ request_id })}`);
  },
  otpTimer: (request_id: string): Promise<DataResponse<InsuranceOtpTimerData>> => {
    return client.get(`/user-requests/${SERVICE_CODES.INSURANCE}/otp-timer?${new URLSearchParams({ request_id })}`);
  },
  createOrder: (formData: Record<any, any>): Promise<DataResponse<InsuranceOrder>> => {
    return client.post(`/user-requests/${SERVICE_CODES.INSURANCE}/create-order`, formData);
  },
  generateOtp: ({
    request_id,
    user_accepted_terms,
  }: {
    request_id: string;
    user_accepted_terms: boolean;
  }): Promise<void> => {
    return client.post(`/user-requests/${SERVICE_CODES.INSURANCE}/generate-otp`, {
      request_id,
      user_accepted_terms,
    });
  },
  validateOtp: (request_id: string, otp: string): Promise<unknown> => {
    return client.post(`/user-requests/${SERVICE_CODES.INSURANCE}/validate-otp`, {
      request_id,
      otp,
    });
  },
};
